// @flow
import * as React from 'react'
import DesktopDateField from './DesktopDateField'
import MobileDateField from './MobileDateField'
import MobileNativeDateField from './MobileNativeDateField'
import { isMobileBrowser } from '../../utils'

// Types
import type { Props as DesktopFieldProps } from './DesktopDateField'

export type Appearance = 'mobile' | 'mobile-native' | 'desktop'
export type Props = DesktopFieldProps & {
  fieldAppearance?: Appearance,
}

// Constants
const APPEARANCES = {
  mobile: MobileDateField,
  'mobile-native': MobileNativeDateField,
  desktop: DesktopDateField,
}

/**
 * Responsive Date field, that can detect the device and show
 * an appropreate implmenetation of the field to the user. Or you
 * can force it to use some exact implementation by `fieldAppearance`
 * prop.
 * @return {React.Element}
 */
const DateField = ({ fieldAppearance, ...restProps }: Props) => {
  let FieldComponent = DesktopDateField
  if (fieldAppearance) {
    FieldComponent = APPEARANCES[fieldAppearance] || APPEARANCES.desktop
  } else if (isMobileBrowser()) {
    FieldComponent = APPEARANCES['mobile-native']
  } else {
    FieldComponent = APPEARANCES.desktop
  }
  return <FieldComponent {...restProps} />
}
DateField.defaultProps = DesktopDateField.defaultProps

export default DateField
